export default __webpack_public_path__ + "static/media/desktop.3a65235b.png";